module.exports = __webpack_public_path__ + "static/media/eek20.4829efe8.JPG";